import React from 'react';
import { Box, Typography } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import BackNavigate from 'component/back-navigate/back-navigate';
import UserInfo from 'pages/users/user-details/user-info';
import UserCardInfo from 'pages/users/user-details/user-card-info';
import { useParams } from 'react-router-dom';
import { useUsersDetailsQuery } from 'store/slices/user/user';
import Image from 'component/image/image';

const UserDetails: React.FC = () => {
    const { userId } = useParams();
    const { data: userInfo } = useUsersDetailsQuery({ userId: userId ?? '' });

    return (
        <>
            <Box mb={pxToRem(5)} display="grid" alignItems="center">
                <BackNavigate navigateUrl={'/user'} />
                <Typography variant={'h5'}>User Details</Typography>
            </Box>
            <Box display={'flex'} flexBasis={'100%'}>
                <Image userId={userInfo?.selectedAvatarId} />
                <UserInfo data={userInfo} />
            </Box>
            <Box mt={pxToRem(20)}>
                <UserCardInfo userId={userId ?? ''} />
            </Box>
            {/*<Box mt={pxToRem(20)}>
                <UserFriendInfo />
            </Box>
            <Box mt={pxToRem(20)}>
                <UserPresentInfo />
            </Box>
            <Box mt={pxToRem(20)}>
                <UserGamesInfo />
            </Box>*/}
        </>
    );
};

export default UserDetails;
